import axiosInstance from '../../utils/axiosConfig';
export const GET_TASKLIST = 'GET_TASKLIST';
export const CLAIM_TASK = 'CLAIM_TASK';
export const UNCLAIM_TASK = 'UNCLAIM_TASK';
export const GET_TASK = 'GET_TASK';
export const COMPLETE_TASK = "COMPLETE_TASK"
export const RESET_PROCESS = 'RESET_PROCESS';
export const UPDATE_TASK_VARIABLE = 'UPDATE_TASK_VARIABLE';


export function getTasksForUser(userId, userGroups, page = 1, limit = 10, filters = {}) {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.post(`${process.env.REACT_APP_BACKEND_URL_MS_WORKFLOW}/getTasksForUser`, { 
                userId, 
                userGroups,
                page,
                limit,
                ...filters
            });
             
            dispatch({
                type: GET_TASKLIST,
                payload: response.data,
            });
          return response;
        } catch (error) {
            dispatch({
                type: GET_TASKLIST,
                payload: null,
            });
            console.error(`Error fetching task list details: ${error.message}`);
            throw error;
        }
    };
}

export async function getTask(taskId, userId) {
    try {
        const response = await axiosInstance.post(process.env.REACT_APP_BACKEND_URL_MS_WORKFLOW+`/task/${taskId}`, { userId });
        return response.data;
    } catch (error) {
        console.error(`Error fetching party details: ${error.message}`);
    }
}

export const claimTask = (taskId, userId) => async (dispatch) => {
    try {
        await axiosInstance.post(process.env.REACT_APP_BACKEND_URL_MS_WORKFLOW+`/task/${taskId}/claim`, { userId });
        dispatch({
            type: CLAIM_TASK,
            payload: { taskId, userId }
        });
    } catch (error) {
        console.error(`Error claiming task: ${error.message}`);
    }
};

export const unclaimTask = (taskId, userId) => async (dispatch) => {
    try {
        await axiosInstance.post(process.env.REACT_APP_BACKEND_URL_MS_WORKFLOW+`/task/${taskId}/unclaim`, { userId });
        dispatch({
            type: UNCLAIM_TASK,
            payload: { taskId, userId }
        });
    } catch (error) {
        console.error(`Error unclaiming task: ${error.message}`);
    }
};
export const getUserGroupLabel = () => {
    try {
        const groupData = localStorage.getItem('groupAuthorities');
        if (!groupData) return null;
        const parsedData = JSON.parse(groupData);
         if (Array.isArray(parsedData) && parsedData.length > 0) {
            return parsedData[0].label; 
        }
        if (parsedData && parsedData.label) {
            return parsedData.label;
        }
        return null;
    } catch (err) {
        console.warn('Failed to parse groupAuthorities from localStorage:', err);
        return null;
    }
};

export const completeTask = (taskId, userId, variables) => async (dispatch) => {
    try {
        const url = `${process.env.REACT_APP_BACKEND_URL_MS_WORKFLOW}/task/${taskId}/complete`;

        const groupLabel = getUserGroupLabel();

        const updatedVariables = {
            ...variables,
            groupExecutingAction: {
                value: groupLabel || 'UNKNOWN_GROUP',
                type: 'String'
            }
        };

        const requestBody = {
            userId,
            variables: updatedVariables
        };

        await axiosInstance.post(url, requestBody);

        dispatch({
            type: COMPLETE_TASK,
            payload: { taskId }
        });
    } catch (error) {
        console.error(`Error completing task: ${error.message}`);
    }
};

export function assignTaskToUser(taskId, userId) {
    return async (dispatch) => {
        try {
            const url = `${process.env.REACT_APP_BACKEND_URL_MS_WORKFLOW}/task/${taskId}/assignee`;
            const requestBody = { userId };
            await axiosInstance.post(url, requestBody); 
        } catch (error) {
            console.error('Error assigning task:', error.message);
            throw error;
        }
    };
}

export const resetProcess = (businessKey, context) => async (dispatch) => {
    try {
        const response = await axiosInstance.post(`${process.env.REACT_APP_BACKEND_URL_MS_WORKFLOW}/reset`, { businessKey, context });
        dispatch({
            type: RESET_PROCESS,
            payload: response.data,
        });
        return response.data;
    } catch (error) {
        console.error('Error resetting process:', error.message);
        throw error;
    }
};

export const sendMessage = (message) => async (dispatch) => {
    try {
        const response = await axiosInstance.post(`${process.env.REACT_APP_BACKEND_URL_MS_WORKFLOW}/message`, message);
        return response.data;
    } catch (error) {
        console.error('Error sending message:', error.message);
        throw error;
    }
}



export const getAllowedJumps = (businessKey, processType) => async (dispatch) => {
    try {
        const response = await axiosInstance.get(`${process.env.REACT_APP_BACKEND_URL_MS_WORKFLOW}/allowed-jumps/${businessKey}?processType=${processType}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching allowed jumps:', error.message);
        throw error;
    }
};

export const forceProcess = (businessKey, toActivityId, processType, userId, reason) => async (dispatch) => {
    try {
        const response = await axiosInstance.post(`${process.env.REACT_APP_BACKEND_URL_MS_WORKFLOW}/force-process`, {
            businessKey,
            toActivityId,
            processType,
            userId,
            reason
        });
        return response.data;
    } catch (error) {
        console.error('Error forcing process:', error.message);
        throw error;
    }
};

export const UpdateTaskVariable = (taskId, varName ,variables) => async (dispatch) => {
    try {
        const url = `${process.env.REACT_APP_BACKEND_URL_MS_WORKFLOW}/UpdateTaskVariable/${taskId}/variables/${varName}`;

        await axiosInstance.put(url, variables);

        dispatch({
            type: UPDATE_TASK_VARIABLE,
            payload: { taskId }
        });
    } catch (error) {
        console.error(`Error update task: ${error.message}`);
    }
};
